import axios from "axios";
// import { getCookie } from "cookies-next";
import Router from "next/router";
import { parseCookies } from "nookies";

const appAxiosBase = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_API_URL,
  timeout: 10000,
	// withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    // "Authorization": `Bearer ${process.env.NEXT_PUBLIC_APP_API_TOKEN}`,
  },
})

// Interceptação para funcionar apenas em useEffect, ou chamadas dentro do react
// Para chamadas em ServerSide, por falta de context e request, não será possível
// capturar os cookies, e portanto não validará o token
appAxiosBase.interceptors.request.use(async config => {
	// axios.get('http://localhost:3000/api/get-token').then(data => console.log('TOKEN', data.data))
	// console.log(config.url, appAxiosBase.interceptors, 'intercept in core')
	const originalHeaders = config.headers
	try {
		const req = config.request
		const {'electy-server@auth-token': user} = parseCookies()
		const token = JSON.parse(user)?.token
		// const res = config.response
		// const user = parseCookies(config.headers, 'electy-server@auth-token')
		// console.log(user, config.headers, 'USER!')
		// const {'electy@token': token} = parseCookies()

		if(token) {
			config.headers["Authorization"] = `Bearer ${token}`
			if(config.url != 'users/me') {
				appAxiosBase.get('users/me')
					.then(data => data)
					.catch( data => {
						if(data.response.status == 403 || data.response.status == 401) {
							Router.push('/usuario/logout')
							return Promise.reject('expired')
						}
					})
			}
		}
	} catch (error) {
		config.headers = originalHeaders
		console.log(error.message, 'appAxiosService.catch')
	}

	return config
})

export const appAxios = appAxiosBase;

export const appMultPartFormAxiosBase = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "multipart/form-data",
    // Authorization: `Bearer ${process.env.NEXT_PUBLIC_APP_API_TOKEN}`,
  },
});

// Interceptação para funcionar apenas em useEffect, ou chamadas dentro do react
// Para chamadas em ServerSide, por falta de context e request, não será possível
// capturar os cookies, e portanto não validará o token
appMultPartFormAxiosBase.interceptors.request.use(config => {
	const originalHeaders = config.headers
	try {
		const {'electy-server@auth-token': user} = parseCookies()
		const token = JSON.parse(user).token
		// const {'electy@token': token} = parseCookies()
		if(token) {
			config.headers["Authorization"] = `Bearer ${token}`
		}
		
		if(config.url != 'users/me') {
			appAxiosBase.get('users/me')
				.then(data => data)
				.catch( data => {
					// if(data.response.status == 403 || data.response.status == 401) {
						Router.push('/usuario/logout')
						return Promise.reject('expired')
					// }
				})
		}
	} catch (error) {
		config.headers = originalHeaders
	}
	return config
})

export const appMultPartFormAxios = appMultPartFormAxiosBase

export const nextApiAxios = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_NEXT_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const nextApiMultPartAxios = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_NEXT_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const consultaCnpj = async (cnpj) => {

	let consultarCNPJ = require('consultar-cnpj');

	return await consultarCNPJ(cnpj, process.env.SECRECT_API_CONSULTA_CNPJ_TOKEN)
		.then(data => {
			if(data.estabelecimento?.situacao_cadastral == 'Ativa') {
				return {
					status: true,
					nome: data.razao_social
				} 
			}
			return {
				status: false,
				msg: 'nao_encontrado'
			}
		})
		.catch(err => {
			return {
				status: false,
				msg: 'api_error'
			}
		})
}

export const consultaCpf = async (cpf, birthdate) => {
	const url = process.env.SECRECT_API_CONSULTA_CPF_URL
	const token = process.env.SECRECT_API_CONSULTA_CPF_TOKEN
	return await fetch(`${url}/cpf?token=${token}&timeout=600&cpf=${cpf}&birthdate=${birthdate}&origem=web`)
		.then(data => {
			return data.json()
		}).then(data => {
			// console.log('CPF - - -', {data})
			if(data.data.length > 0) {
				data = data.data[0]
			}

			if(data?.situacao_cadastral == 'REGULAR') {
				return {
					status: true,
					message: 'OK',
					nome: data?.nome_fantasia
				}
			}

			if(data.code == 603) {
				console.log('API de validação do CPF não está funcionando');
				return {
					status: true,
					message: 'OK',
				}
			}
			
			return {
				status: false,
				msg: 'nao_encontrado'
			}
		}).catch(err => {
			return {
				status: false,
				msg: 'api_error'
			}
		});
}